anonymousConsentActiveGroups